<template lang='pug'>
  v-container.px-3.orders-container(fluid)
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :right="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-dialog( :fullscreen="isMobile" width="500" persistent :value='detailsDialog' transition="dialog-bottom-transition")
      Details(v-if='detailsDialog' :request='currentRequest' @close ='detailsDialog=false' admin="order" @showProduct='productDialog = true')
    v-dialog( persistent  :value='showBillDialog'  max-width='600px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        bill-preview(@close='showBillDialog=false' @showSupportImage='showSupportImage' @showProduct='productDialog = true' :item="currentTransaction" :currentType='currentType' )
    v-dialog( persistent  :value='purchaseDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      PurchaseForm(v-if='purchaseDialog' @close="purchaseDialog = false")
    v-dialog( :fullscreen='isMobile' persistent :key='currentItem.name' :value='productDialog'  max-width='800px'   transition="dialog-bottom-transition")
      Preview(v-if='productDialog' :model ='currentItem' @close='productDialog=false')
    //- Content
    v-row.px-3.justify-space-between.align-center.my-0
      v-col(cols="6" xs="6" sm="6" md="6")
        v-btn.main-btn-gradient(small color='#3cbbc2' style="height: 48px;" @click="onexport()")
          v-icon mdi-arrow-collapse-down
          | Exportar
      v-col.d-flex.justify-end(cols="6" xs="6" sm="6" md="6")
        //- Update btn
        v-btn.main-btn-gradient(small style="height: 48px;" @click="fetch('sales', true, null)")
          v-icon mdi-refresh
        //- Date filter
        v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
          template(v-slot:activator='{ on }')
            v-btn.main-btn-gradient(smal color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
              v-icon mdi-calendar
              | {{$t('orders_movements.dates')}}
          v-card(style="border:3px solid #3cbbc2;").pa-2
            date-filter(@closeMenu="menu = false" :currentType= 'currentType',)
    v-row.px-5.my-0
      MovementTransactions(
        title="Movimientos ordenes"
        :movements="transactions.length.toString()"
        :total="transactionTotals.total.toFixed(2)"
        :utility="transactionTotals.revenue.toFixed(2)"
      )
    v-row.px-5.my-0.pb-5
      v-card.rounded-lg.pa-3( width="100%")
        v-row
          v-col.pb-0(cols="12" xs="6" sm="6" md="4")
            v-select.rounded-xl(
              :label="$t('orders_movements.filter_by_store')",
              elevation=0
              outlined
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row.my-1
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
          v-col.py-0.d-flex.align-center.justify-center(cols="12" xs="6" sm="6" md="8")
            .rest-type.rounded-lg
            p.ml-1.font-weight-bold(style="font-size: 17px;") Orden de Restaurant
        v-row
          v-col(cols='12' md='12')
            .card-transactions
              v-progress-linear(v-if="loading" indeterminate color="#008e95")
              //- Desktop
              .show-table-desktop
                v-data-table.elevation-0(:headers="headers" :items="transactions || []"  item-key="name" :search="search")
                  //- template(v-slot:top="")
                    v-toolbar(flat="" color="white")
                      v-toolbar-title {{$t('orders_movements.title_table')}}
                      .flex-grow-1
                  template( v-slot:item="props" )
                    tr(style="cursor: pointer;")
                      td.text-xs-left(@click="openDetail(props.item)" :style="props.item.delivery === 'Restaurant' ? 'border-left: 5px solid #FF5722' : ''")
                        .datatable-cell-wrapper {{ props.item.reference_number }}
                      td.text-xs-left(style="max-width:250px;" @click="openDetail(props.item)")
                        span.mr-1 {{productsInOrder(props.item.items)}}
                      td.text-xs-left(@click="openDetail(props.item)")
                        .datatable-cell-wrapper  {{ props.item.time | moment}} {{props.item.time | momentHours}}
                      td.text-xs-left(@click="openDetail(props.item)")
                        .datatable-cell-wrapper {{props.item.location_from ? props.item.location_from.name : ''}}
                      td.text-xs-left(@click="openDetail(props.item)")
                        .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                      td.text-xs-left(@click="openDetail(props.item)")
                        .datatable-cell-wrapper(v-if="props.item.delivery === 'Restaurant'") {{props.item.delivery}}
                        .datatable-cell-wrapper(v-else) {{props.item.delivery === 'delivery' ? 'Domicilio' : 'Buscar en el establecimiento'}}
                      td.text-xs-left(@click="openDetail(props.item)")
                        .datatable-cell-wrapper {{props.item.delivery === 'delivery' ? props.item.client.direction.direction : 'No registra'}}
                      td.text-xs-left(@click="openDetail(props.item)")
                        .datatable-cell-wrapper {{props.item.method ? props.item.method : 'Efectivo'}}
                      td.text-xs-center
                        v-select(:disabled="!(props.item.status != 'canceled' && props.item.status != 'completed') || (props.item.status === 'process' && props.item.delivery === 'delivery') " @change="changeStatus(props.item, $event)" style="max-width: 150px;" :items='itemsState' filled='' label='Estado de la Orden' :value="translateOrderStatus(props.item.status)")
              //- Mobile
              v-list.show-table-mobile(two-line="" v-if="filteredTransactions.length > 0")
                v-list-item-group(style="width: 100%;")
                  template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                    v-list-item(:key="item.reference_number" :class="getClass(item)" :style="item.delivery === 'Restaurant' ? 'border-left: 5px solid #FF5722' : ''").notification
                        template(v-slot:default="{ active, toggle }")
                            v-list-item-content(@click="openDetail(item)")
                                p.font-weight-bold # {{item.reference_number}}
                                p.mt-2 {{item.location_from.name}}
                                p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                span.mt-2(v-if="item.delivery === 'Restaurant'") {{item.delivery}}
                                span.mt-2(v-else) {{item.delivery === 'delivery' ? 'Domicilio' : 'Buscar en el establecimiento'}}
                                // span.mt-2 {{item.delivery === 'delivery' ? 'Domicilio' : 'Buscar en el establecimiento'}}
                                span(v-if="item.delivery === 'delivery'").mt-2 {{item.client.direction.direction}}
                                span.mt-2.font-weight-bold.notification__price ${{item.total}}
                            v-list-item-action
                              v-select(:disabled="!(item.status != 'canceled' && item.status != 'completed') " @change="changeStatus(item, $event)" style="max-width: 150px;" :items='itemsState' filled='' label='Estado de la Orden' :value="translateOrderStatus(item.status)")
                        v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                  v-pagination.my-4(v-model="page" :length="pageNumber")
              .show-table-mobile(v-else)
                NoResults(title="No tienes ordenes", description="Puedes ver tus ordenes en otro rango de fechas")
    //- OldValue
    //- v-layout(wrap='')
      v-flex(md12='' :style="isMobile ? 'padding-left: 20px !important; padding-right: 20px !important;': ''").pl-3.pr-3
        // v-btn(color="#009da5" fab small dark="" v-if="isMobile && $route.name !== 'shops'" @click="$router.go(-1)").mt-2.ml-5
          v-icon(size="25") mdi-arrow-left
        v-col(v-if="isMobile" cols="12" style="position: relative;")
          v-icon(style="z-index: 10; position: absolute; left: 0; top: 0;" size="65" color="#30b5bb" @click="$router.go(-1)") mdi-chevron-left
          h2.orders__title.orders__underline Ordenes
        v-card(v-if="!isMobile")
          v-card-title {{$t('orders_movements.title')}}
          .text-center(style="display:flex; align-items:flex-start;margin-left: 25px !important").mt-2
            .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0(
              :label="$t('orders_movements.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
          v-row.pr-5.pl-1(v-if="isMobile")
                    img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          //-
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="fetch()" height="20" outlined).category-card.py-6.mx-4.mb-8
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Actualizar
                    img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          v-layout.bill-action__button-row().my-2
          v-flex(style='display:flex; flex-direction: row; flex-wrap: wrap; justify-content:flex-start; align-items:center;')
            v-flex(sm6='', xs12='', md6='', lg3='')
              base-material-stats-card( v-if ='!!transactions'  color='warning', icon='mdi-swap-vertical', small-value='#' :title="$t('orders_movements.movements')", :value='transactions.length.toString()')
            v-flex(sm6='', xs12='', md6='', lg3='')
              base-material-stats-card( color='cyan', icon='mdi-currency-usd', small-value='$' :title="$t('orders_movements.total')", :value=' transactionTotals.total.toFixed(2) ')
            v-flex(sm6='', xs12='', md6='', lg3='')
              base-material-stats-card( color='#008E95', icon='mdi-currency-usd', small-value='$' :title="$t('orders_movements.utility')", :value=' transactionTotals.revenue.toFixed(2) ')
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            v-card-title
              v-text-field(v-model='search' append-outer-icon='mdi-search', :label="$t('orders_movements.search')", placeholder="Buscar por referencia o establecimiento" single-line='', hide-details='')
            v-data-table.elevation-1(:headers="headers" :items="transactions || []"  item-key="name" :search="search")
              template(v-slot:top="")
                v-toolbar(flat="" color="white")
                  v-toolbar-title {{$t('orders_movements.title_table')}}
                  .flex-grow-1
              template( v-slot:item="props" )
                tr(style="cursor: pointer;")
                  td.text-xs-left(@click="openDetail(props.item)")
                    .datatable-cell-wrapper {{ props.item.reference_number }}
                  td.text-xs-left(style="max-width:250px;" @click="openDetail(props.item)")
                    span.mr-1 {{productsInOrder(props.item.items)}}
                  td.text-xs-left(@click="openDetail(props.item)")
                    .datatable-cell-wrapper  {{ props.item.time | moment}} {{props.item.time | momentHours}}
                  td.text-xs-left(@click="openDetail(props.item)")
                    .datatable-cell-wrapper {{props.item.location_from ? props.item.location_from.name : ''}}
                  td.text-xs-left(@click="openDetail(props.item)")
                    .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                  td.text-xs-left(@click="openDetail(props.item)")
                    .datatable-cell-wrapper {{props.item.delivery === 'delivery' ? 'Domicilio' : 'Buscar en el establecimiento'}}
                  td.text-xs-left(@click="openDetail(props.item)")
                    .datatable-cell-wrapper {{props.item.delivery === 'delivery' ? props.item.client.direction.direction : 'No registra'}}
                  td.text-xs-left(@click="openDetail(props.item)")
                    .datatable-cell-wrapper {{props.item.method ? props.item.method : 'Efectivo'}}
                  td.text-xs-center
                    v-select(:disabled="!(props.item.status != 'canceled' && props.item.status != 'completed') || (props.item.status === 'process' && props.item.delivery === 'delivery') " @change="changeStatus(props.item, $event)" style="max-width: 150px;" :items='itemsState' filled='' label='Estado de la Orden' :value="translateOrderStatus(props.item.status)")
        v-container(v-else)
          .text-center(style="display:flex; align-items:flex-start;margin-left: 15px !important").mt-2
            .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0.mr-4(
              :label="$t('orders_movements.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
            v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2' small dark='', v-on='on' style="height: 38px;").mt-0
                  v-icon mdi-calendar
              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="menu = false" :currentType= 'currentType',)
          v-row.pr-5.pl-1
            v-col
              v-btn.ma-2.white--text.btn-transaction(style='margin: 2px;' block @click="fetch()")
                | Actualizar
                v-icon(right="" dark="")
                  | mdi-refresh
          //-
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="fetch()" height="20" outlined).category-card.py-6.mx-4.mb-8
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Actualizar
                    img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          v-row.px-2
            v-col(cols="12")
              mobileCard(color='#008E95', icon='mdi-currency-usd', valueIcon='$' :title="$t('orders_movements.utility')", :value='transactionTotals.revenue.toFixed(2)')
            v-col(cols="12")
              mobileCard(color='cyan', icon='mdi-currency-usd', valueIcon='$', :title="$t('orders_movements.total')", :value='transactionTotals.total.toFixed(2)')
            v-col(cols="12")
              mobileCard(v-if ='!!transactions', color='warning', valueIcon='#', icon='mdi-swap-vertical', :title="$t('orders_movements.movements')", :value='transactions.length.toString()')
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            v-card-title
              v-text-field(v-model='search' outlined prepend-inner-icon="mdi-magnify" placeholder="Buscar por referencia o establecimiento")
            v-flex(md12='' style="max-width: 700px").mx-auto.mt-3
              v-list(two-line="" v-if="filteredTransactions.length > 0")
                  v-list-item-group
                    template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                      v-list-item(:key="item.reference_number" :class="getClass(item)").notification
                          template(v-slot:default="{ active, toggle }")
                              v-list-item-content(@click="openDetail(item)")
                                  p.font-weight-bold # {{item.reference_number}}
                                  p.mt-2 {{item.location_from.name}}
                                  p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                  span.mt-2 {{item.delivery === 'delivery' ? 'Domicilio' : 'Buscar en el establecimiento'}}
                                  span(v-if="item.delivery === 'delivery'").mt-2 {{item.client.direction.direction}}
                                  span.mt-2.font-weight-bold.notification__price ${{item.total}}
                              v-list-item-action
                                v-select(:disabled="!(item.status != 'canceled' && item.status != 'completed') " @change="changeStatus(item, $event)" style="max-width: 150px;" :items='itemsState' filled='' label='Estado de la Orden' :value="translateOrderStatus(item.status)")
                          v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                    v-pagination.my-4(v-model="page" :length="pageNumber")
              template(v-else)
                NoResults(title="No tienes ordenes", description="Puedes ver tus ordenes en otro rango de fechas")
</template>

<script>
  import moment from 'moment'
  import DateFilter from '../../../components/custom/filters/DateFilter'
  import PurchaseForm from '../../../components/custom/forms/PurchaseForm'
  import TransferForm from '../../../components/custom/forms/TransferForm'
  import Preview from '../../../components/custom/preview/ProductPreview'
  import BillPreview from '../../../components/custom/preview/transactions/OrdersBillPreview'
  import loaders from '../../../plugins/mixins/loaders'
  import Swal from 'sweetalert2'
  import updateIcon from '@/assets/icons/home/update.png'
  export default {
    components: {
      BillPreview: BillPreview,
      Preview: Preview,
      PurchaseForm: PurchaseForm,
      TransferForm: TransferForm,
      DateFilter: DateFilter,
      Details: () => import('@/views/marketplace/component/profile/RequestDetails'),
      NoResults: () => import('@/components/custom/NoResults'),
      mobileCard: () => import('@/views/custom/transactions/MobileCard.vue'),
      MovementTransactions: () => import('@/components/custom/transactions/movement_transactions'),
    },
    filters: {
      numberFormat (val) {
        if (val) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      moment: function (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      momentHours: function (date) {
        return moment(date).format('hh:mm a')
      },
      status: function (status) {
        let responseStatus = ''
        switch (status) {
          case ('pending'):
            responseStatus = 'Pendiente'
            break
          case ('process'):
            responseStatus = 'Enviado'
            break
          case ('completed'):
            responseStatus = 'Completo'
            break
          case ('canceled'):
            responseStatus = 'Cancelado'
            break
        }
        return responseStatus
      },
    },
    mixins: [loaders],
    props: {
      shop: null,
    },
    data () {
      return {
        loading: false,
        updateIcon,
        dateFrom: '',
        dateTo: '',
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        itemsState: [
          'Pendiente',
          'En proceso',
          'Completada',
          'Cancelada',
        ],
        stateSelect: 'Pendiente',
        menu: false,
        currentLocation: null,
        select: {},
        currentRequest: '',
        detailsDialog: false,
        currentTransaction: null,
        purchaseDialog: false,
        transferDialog: false,
        showBillDialog: false,
        search: '',
        restrictions: [],
        page: 1,
        currentType: '',
        createItemDialog: false,
        productDialog: false,
        shopsList: [],
        collaboratorsList: [],
        headers: [
          {
            sortable: false,
            text: this.$t('orders_movements.table_headers.reference_number'),
            value: 'reference_number',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('orders_movements.table_headers.products'),
            value: 'items',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('orders_movements.table_headers.time'),
            value: 'time',
            align: 'left',

          },
          {
            sortable: false,
            text: this.$t('orders_movements.table_headers.location'),
            value: 'location_from.name',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('orders_movements.table_headers.total'),
            value: 'total',
            align: 'left',

          },
          {
            sortable: false,
            text: 'Opción de entrega',
            value: 'delivery',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('orders_movements.table_headers.direction'),
            value: 'address',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('orders_movements.table_headers.paymentMethodOrder'),
            value: 'method',
            align: 'left',

          },
          {
            text: this.$t('orders_movements.table_headers.actions'),
            value: 'actions',
            sortable: false,
          },
        ],
      }
    },
    computed: {
      plan_reactivate () {
        return this.$store.state.payment.plan_reactivate
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      revenue () {
        return this.$store.getters['transactions/getRevenueTotal']
      },
      currentItem () {
        return this.$store.getters['products/getCurrentItem']
      },

      products () {
        return [
          {
            name: 'Todos',
            value: '',
          },
        ]
      },
      orders () {
        const arrResponse = this.$store.state.transactions.orders
        if (this.shop && arrResponse) {
          return arrResponse.filter(item => {
            return item.location_from.id === this.shop.id
          })
        } else {
          return arrResponse
        }
      },
      transactions () {
        const vm = this
        let arrResponse = []
        if (!!vm.currentLocation && !!vm.orders) {
          // console.log('se escogio : ' + vm.currentLocation.name)
          arrResponse = vm.orders.filter((el) => {
            if (el.location_from.id === vm.currentLocation.id) {
              // console.log(el.location_from.id, vm.currentLocation.id)
              return true
            }
          })
        } else {
          // console.log('entra en nulo')
          arrResponse = vm.orders || []
        }
        return arrResponse.reverse()
      },
      transactionTotals () {
        const vm = this
        let total = 0
        let revenue = 0
        // console.log(revenue)
        if (vm.transactions) {
          const list = vm.transactions || {}
          list.forEach(element => {
            // if( Vue.moment().isSame(element.time, state.currentDateFilter))
            total += +element.total
            if (element.items) {
              element.items.forEach(item => {
                if (item.purchase && item.pricewithouttax) {
                  revenue += (+item.pricewithouttax - +item.purchase) * +item.amount
                } else {
                  revenue += (+item.price - +item.purchase) * +item.amount
                }
              })
            }
          })
          return {
            total: total,
            revenue: revenue,
          }
        }
        return {
          total: 0,
          revenue: 0,
        }
      },
      allItems () {
        return this.$store.getters['products/getAllItems']
      },
      pageNumber () {
        if (this.isMobile) {
          return Math.ceil(this.filteredTransactions.length / 10)
        } else {
          return Math.ceil(this.transactions.length / 10)
        }
      },
      filteredTransactions () {
        return this.transactions.filter((transaction) => {
          return (transaction.location_from.name.toLowerCase().match(this.search.toLowerCase()) || transaction.reference_number.toString().includes(this.search))
        })
      },
    },
    watch: {
      transactions (val, oldval) {
        const vm = this
        vm.loading = false
      },
      $route (to, from) {
        // react to route changes...
        if (this.$route.params.type) {
          this.currentType = this.$route.params.type
          // console.log(this.$route.params.type)
        } else this.currentType = 'orders'
      },
      'restrictions.restrictions.currentAmountSale' (newVal, oldVal) {
        const vm = this
        if (newVal >= vm.plan_reactivate.data.restrictions.maxAmountSale) {
          vm.$store.state.transactions.orders.forEach(element => {
            if (element.status === 'pending' || element.status === 'process') {
              vm.changeStatus(element, 'canceled')
            }
          })
        }
      },
    },
    created () {
      this.currentType = this.$route.params.type
      this.fetch(this.currentType)
      this.shopsList = this.$store.getters['shops/getItems']
      this.$store.dispatch('users/getRestrictions').then(res => {
        // console.log(res)
        this.restrictions = res
      })
      this.$store.dispatch('users/getCollaborators').then(res => {
        this.collaboratorsList = res
      })
    },
    beforeDestroy () {
      this.$store.dispatch('transactions/clearTransactions').then(function (res) {
        // console.log('transactions cleared')
      })
      this.clearShopSelection()
    },
    methods: {
      productsInOrder (products) {
        // span(v-for='product in props.item.items') {{product.name}},
        let productsString = ''
        products.forEach((product, index) => {
          if (index !== products.length - 1) {
            productsString += product.name + ', '
          } else {
            productsString += product.name
          }
        })
        if (productsString.length > 50) {
          return productsString.substring(0, 50) + '...'
        } else {
          return productsString
        }
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      checkAvailability (item) {
        const vm = this
        vm.checkingAvailability = true
        const payload = {
          lngInit: item.location_from.addressInfo.lng,
          latInit: item.location_from.addressInfo.lat,
        }
        vm.$store.dispatch('delivery/isDeliveryAvailable', payload).then((res) => {
          // res.acceptanceAnswer = 'OUT_OF_COVERAGE'
          if (res.acceptanceAnswer === 'ACCEPTED') {
            const info = {
              latInicial: item.location_from.addressInfo.lat.toString(),
              lgnInicial: item.location_from.addressInfo.lng.toString(),
              dirInicial: item.location_from.addressInfo.addressgoogle,
              latFinal: item.client.direction.location.lat.toString(),
              lgnFinal: item.client.direction.location.lng.toString(),
              dirDestino: item.client.direction.direction,
              idaRegreso: 'NO',
            }
            vm.$store.dispatch('delivery/deliveryCost', info).then((resp) => {
              if (resp.success) {
                const service = {
                  userId: item.client.id,
                  reference_number: item.reference_number,
                  idaRegreso: 'NO',
                  dirInicial: item.location_from.addressInfo.addressgoogle,
                  latInicial: item.location_from.addressInfo.lat.toString(),
                  lgnInicial: item.location_from.addressInfo.lng.toString(),
                  dirDestino: item.client.direction.direction,
                  latFinal: item.client.direction.location.lat.toString(),
                  lgnFinal: item.client.direction.location.lng.toString(),
                  complementoInicial: '',
                  complementoDestino: '',
                  tipoPago: '1', // efectivo
                  valorMensajero: (resp.costo).toString(),
                  observacion: '',
                  valorCompra: item.cash,
                }
                vm.$store.dispatch('delivery/createService', service).then((respt) => {
                  // console.log(respt)
                  /* if (res.success) {
                    vm.checkingAvailability = true
                  } */
                  item.status = 'process'
                  const idOrden = item.idOrden
                  const uid = vm.$store.state.users.user.uid
                  const ban = true
                  const data = {
                    banClientAdmin: ban,
                    idOrder: idOrden,
                    statusOrder: 'process',
                    idUser: uid,
                    sendLimitWarning: false,
                  }
                  vm.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
                    vm.setDataNotification(true, 'green', 'Se actualizó la orden de manera correcta.')
                  })
                  vm.checkingAvailability = false
                })
              } else {
                item.status = 'pending'
                vm.changeStatus(item, 'Pendiente')
                vm.setDataNotification(true, 'red', 'Hubo un problema intenta otra vez en unos minutos.')
              }
            })
          } else {
            let msg
            if (res.acceptanceAnswer === 'REJECTED_PER_CAPACITY') {
              msg = 'No hay mensajeros disponibles en tu zona. Intenta de nuevo en unos minutos.'
              item.status = 'pending'
              vm.changeStatus(item, 'Pendiente')
            } else if (res.acceptanceAnswer === 'OUT_OF_COVERAGE') {
              msg = 'No hay cobertura de domicilios en tu zona.'
              item.status = 'canceled'
              vm.changeStatus(item, 'Cancelada')
            }
            vm.setDataNotification(true, 'red', msg)
          }
        })
      },
      changeStatus (item, event) {
        const vm = this
        event = vm.translateOrderStatus(event)
        const idOrden = item.idOrden
        const uid = vm.$store.state.users.user.uid
        const ban = true
        const soldOutItems = []
        const data = {
          banClientAdmin: ban,
          idOrder: idOrden,
          statusOrder: event,
          idUser: uid,
          sendLimitWarning: false,
        }
        if (event === 'completed') {
          // se verifica contra la bd si hay stock para completar esa orden
          const items = Object.values(item.items)
          items.forEach(itemOrder => {
            if (itemOrder.type === 'bundle') {
              const stock = vm.getBundleStock(item.location_from, itemOrder.ingredients)
              if (stock === 0) {
                soldOutItems.push(itemOrder.name)
              }
            } else if (itemOrder.type === 'product') {
              const inventoryProduct = vm.allItems.find(el => itemOrder.id === el.id)
              const inventoryProductCurrentLocation = +inventoryProduct.location[item.location_from.id].stock
              const available = inventoryProductCurrentLocation - item.amount
              if (available <= 0) {
                soldOutItems.push(itemOrder.name)
              }
            }
          })
          /* if (item.referral !== '') {
            const shopOwner = item.user.id
            const shopId = item.location_from.id
            const dataRequest = { shopOwner: shopOwner, shopId: shopId, isReferral: true, uid: item.referral }
            vm.$store.dispatch('promotions/addFirstBuyCoupon', dataRequest)
          }
          if (vm.restrictions.data.name === 'Plan Reactivate') {
            vm.restrictions.restrictions.currentAmountSale += 1
            if (+vm.restrictions.restrictions.currentAmountSale >= vm.plan_reactivate.data.limitWarning) {
              // console.log('entre')
              data.sendLimitWarning = true
              data.limitWarning = vm.plan_reactivate.data.limitWarning
              data.maxAmountSale = vm.plan_reactivate.data.restrictions.maxAmountSale
              // console.log(data)
            }
            const dataRestrictions = {
              shops: vm.shopsList,
              currentAmountSale: vm.restrictions.restrictions.currentAmountSale,
              collaborators: vm.collaboratorsList,
            }
            vm.$store.dispatch('payment/getSubscriptionData', dataRestrictions).then(res => {

            })
          } */
        }
        // console.log(data, event)
        if (soldOutItems.length === 0) {
          if (event === 'process' && item.delivery === 'delivery') {
            item.status = 'process'
            vm.checkAvailability(item)
          } else {
            vm.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
              // console.log(res)
              vm.setDataNotification(true, 'green', 'Se actualizó la orden de manera correcta.')
              // vm.currentType = vm.$route.params.type
              // vm.fetch(vm.currentType)
            })
          }
        } else {
          item.status = 'pending'
          vm.$forceUpdate()
          data.statusOrder = 'pending'
          vm.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
          })
          let text = '<p> Esta orden no puede ser completada debido a que los siguientes productos estan agotados: </p>'
          soldOutItems.forEach(element => {
            text += '<p style="margin-bottom: 10px">' + element + ', </p>'
          })
          text += 'El estado de la orden se pasara a pendiente'
          Swal.fire({
            html: text,
            title: '',
            icon: 'error',
          })
        }
      },
      getBundleStock (location, ingredients) {
        const vm = this
        try {
          const quantities = []
          ingredients.forEach(function (el) {
            const currentItem = vm.allItems.find(item => item.id === el.id)
            if (currentItem) {
              if (currentItem.location[location.id]) { quantities.push(Math.floor(currentItem.location[location.id].stock / el.amount)) } else quantities.push(0)
            } else quantities.push(0)
          })
          return Math.min(...quantities) || 0
        } catch (err) {
          // console.log(err)
          return 0
        }
      },
      showBill (item) {
        // console.log(item)
        this.currentTransaction = item
        // console.log(item)
        this.showBillDialog = !this.showBillDialog
      },
      showSupportImage (url) {
        this.$swal({
          title: 'Comprobante',
          text: 'Modal with a custom image.',
          // imageUrl: url,
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: 'Custom image',
          html: `
              <a target="_blank" href="${url}" download>
                <img style='max-height: 500px;' src="${url}" alt="comprobante">
              </a>
                    `,
          showConfirmButton: true,
        })
      },
      loadLog (type, dateFrom, dateTo) {
        const vm = this
        vm.$store.dispatch('transactions/loadLog', [type, dateFrom, dateTo, true]).then(function () {
          vm.loading = false
        })
      },
      fetch (type = 'orders') {
        // vm.$store.commit('setLoading',true);
        const vm = this
        vm.loading = true
        const dateFrom = this.$moment().format('YYYY-MM-DD')
        this.loadLog(type, dateFrom, this.$moment(dateFrom).add(1, 'days').format('YYYY-MM-DD'), true)
      },
      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {
        })
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('shops/setCurrentItem', item).then(function () {
          // console.log(vm.$store.getters['shops/getCurrentItem'])
        })
      },
      setSearchCriteria (val) {
        const vm = this

        vm.$store.dispatch('transactions/setFilterCriteria', val).then(function () {
          //
        })
      },
      setFilterCriteria () {
        const vm = this

        this.$store.dispatch('transactions/setFilterCriteria', vm.select).then(function () {
          //
        })
      },
      translateOrderStatus (status) {
        switch (status) {
          case 'Pendiente':
            return 'pending'
          case 'En proceso':
            return 'process'
          case 'Completada':
            return 'completed'
          case 'Cancelada':
            return 'canceled'
          case 'pending':
            return 'Pendiente'
          case 'process':
            return 'En proceso'
          case 'completed':
            return 'Completada'
          case 'canceled':
            return 'Cancelada'
        }
      },
      getClass (item) {
        let status = ''
        switch (item.status) {
          case ('pending'):
            status = 'notification__pending'
            break
          case ('process'):
            status = 'notification__sent'
            break
          case ('completed'):
            status = 'notification__complete'
            break
        }
        return status
      },
      openDetail (item) {
        const vm = this
        vm.currentRequest = item
        vm.detailsDialog = true
      },
    },
  }
</script>

<style lang='scss' scoped>
.orders-container{
  .rest-type{
    height: 20px;
    width: 5px;
    background: #FF5722;
  }
  .card-transactions{

    overflow-y: scroll !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .show-table-mobile{
    padding-bottom: 50px;
  }
  @media(min-width: 760px) {
    .show-table-mobile{
      display: none !important;
    }
    .show-table-desktop{
      display: block !important;
    }
  }
  @media(max-width: 1100px) {
    .show-table-mobile{
      display: flex !important;
    }
    .show-table-desktop{
      display: none !important;
    }
  }
  .notification{
    display: flex;
    width: 95%;
    margin: 0 auto;
    // border-radius: 10px !important;
    box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
    &__container{
      @media (max-width: 1024px){
        background: transparent;
      }
    }
    /* &__pending{
      border-left: 4px solid #ff5252;
      font-weight: bold;
    } */
    /* &__sent{
      border-left: 4px solid #fb8c00;
      font-weight: bold;
    } */
    &__complete{
      border-left: 4px solid green;
      font-weight: bold;
    }
    &__date{
      font-size: 13px;
      color: #808184;
    }
    &__price{
      color: #35a3a9 !important;
    }
    &__description{
      color: #808184;
      font-size: 18px;
      font-weight: 300;
      line-height: 1.2;
    }
  }
  .orders {
    &__title {
      text-align: center;
      color:#a3a4a5;
    }

    &__underline {
      position: relative;

      &:after {
        content:' ';
        position: absolute;
        top:120%;
        left:50%;
        width: 8rem;
        border:2px solid #30b5bb;
        border-radius:4px;
        transform:translateX(-50%);
      }
    }
  }

}
</style>
